import { useEffect } from 'react';

import { sendYakliView } from '../services/topicView';

/**
 * Signale une ouverture de permalien (objet `yakli`) au montage client de la page
 * de deep-link.
 *
 * Remplace le comptage émis par le rendu serveur (`foundYakli`, dans les deux
 * implémentations jumelles `services/thread.js` et `controllers/thread_controller.js`),
 * qui comptait un événement à chaque RENDU de la page — donc les régénérations ISR et,
 * surtout, tous les robots : 693 510 événements contre 559 vues humaines sur 18 jours.
 *
 * Monté uniquement sur `Discussion`, la seule surface qui affiche un permalien. La page
 * topic ordinaire ne doit PAS l'appeler : elle n'est pas une ouverture de lien direct.
 *
 * Client-only (no-op en SSR), no-op tant que `threadId` est absent. Le serveur dérive le
 * site du thread lui-même, donc rien à fournir de plus.
 */
export const useYakliView = (threadId: string | null | undefined): void => {
  useEffect(() => {
    if (!threadId) return;
    sendYakliView(threadId);
  }, [threadId]);
};
